__turbopack_context__.v({
  "card": "MSolmq_card",
});
